export default __webpack_public_path__ + "cloud-large-0b2361b9b8c473c817048427d3818ff9.png";